import BOImagePage from "../components/pages/BOImage/BOImagePage";
import FeedPage from "../components/pages/Feed/FeedPage";
import PageNotFound from "../components/pages/PageNotFound";
import PasswordPage from "../components/pages/PasswordPage";
import HomePage from "../components/pages/Homepage/Homepage";
import SearchPage from "../components/pages/Feed/SearchPage";
import RetailStore from "../components/pages/RetailStore/Index";
import SearchPageV2 from "../components/pages/Feed/SearchPageV2";
import SpeechPage from "../components/pages/SpeechPage";

export const AllRoutes = [
    {
        path: "/",
        element: <HomePage />
    },
    {
        path: "/:BOImageID",
        element: <FeedPage />
    },
    /*{
        path: "/boimage/:BOImageID", //FOR PLANNING BUT NOT WORKING YET
        element: <FeedPage />
    },
    {
        path: "/bopic/:BOImageID", //FOR PLANNING BUT NOT WORKING YET
        element: <FeedPage />
    },*/
    {
        path: "/password",
        element: <PasswordPage />
    },
    {
        path: "/explore",
        element: <FeedPage />
    },
    {
        path: "/feed/:brandID",
        element: <FeedPage />
    },
    {
        path: "/pic/:GTINourID",
        exact: true,
        element: <FeedPage />
    },
    {
        path: "/boimage",
        element: <BOImagePage />
    },
    {
        path: "/search",
        element: <SearchPageV2 />
    },

    {
        path: "/search2",
        element: <SearchPage />
    },
    {
        path: "/404",
        element: <PageNotFound />
    },
    {
        path: "/retailerStores/:retailBrandID",
        exact: true,
        element: <RetailStore />
    },
    {
        path: "*",
        element: <PageNotFound />
    },
    {
        path: "/speech",
        element: <SpeechPage />
    }
];
